import { snakeCase } from 'lodash';

import {
  SEMRushWebsiteTrafficByMonthModel,
  SEMRushWebsiteTrafficModel,
} from '../model/SEMRushWebsiteTrafficModel';
import { makeActionKey } from './CrudActionContainer';
import { getActionHookBuilder } from './action-hook-builder';

const entityName = klass =>
  snakeCase(klass.name)
    .toUpperCase()
    .replace(/_ACTIONS$/, '');

class WebsiteReportSummaryActions {
  entity: string;
  setTrafficLoadedAction: string;
  setTrafficTotalsAction: string;
  setTrafficMonthlyAction: string;
  setTrafficBusyAction: string;
  setTopLandingsAction: string;
  setCompetitorsAction: string;
  setWebsiteSummaryAction: string;
  resetAction: string;

  constructor() {
    this.entity = entityName(this.constructor);
    this.setTrafficLoadedAction = makeActionKey(
      this.entity,
      'SET_TRAFFIC_LOADED',
    );
    this.setTrafficTotalsAction = makeActionKey(
      this.entity,
      'SET_TRAFFIC_TOTALS',
    );
    this.setTrafficMonthlyAction = makeActionKey(
      this.entity,
      'SET_TRAFFIC_MONTHLY',
    );
    this.setTopLandingsAction = makeActionKey(this.entity, 'SET_TOP_LANDINGS');
    this.setCompetitorsAction = makeActionKey(this.entity, 'SET_COMPETITORS');
    this.setWebsiteSummaryAction = makeActionKey(
      this.entity,
      'SET_ WEBSITE_SUMMARY',
    );
    this.setTrafficBusyAction = makeActionKey(this.entity, 'SET_TRAFFIC_BUSY');
    this.resetAction = makeActionKey(this.entity, 'RESET_TRAFFIC');
  }

  setTrafficLoaded(payload: boolean = true) {
    return {
      type: this.setTrafficLoadedAction,
      payload,
    };
  }

  setTrafficTotals(payload: SEMRushWebsiteTrafficModel) {
    return {
      type: this.setTrafficTotalsAction,
      payload,
    };
  }

  setTrafficMonthly(payload: SEMRushWebsiteTrafficByMonthModel) {
    return {
      type: this.setTrafficMonthlyAction,
      payload,
    };
  }

  setTopLiandings(payload) {
    return {
      type: this.setTopLandingsAction,
      payload,
    };
  }

  setCompetitors(payload) {
    return {
      type: this.setCompetitorsAction,
      payload,
    };
  }

  setWebsiteSummary(payload) {
    return {
      type: this.setWebsiteSummaryAction,
      payload,
    };
  }

  setTrafficBusy(payload: boolean = true) {
    return {
      type: this.setTrafficBusyAction,
      payload,
    };
  }

  reset() {
    return { type: this.resetAction };
  }
}

export const websiteReportSummaryActions = new WebsiteReportSummaryActions();
export default websiteReportSummaryActions;

export const useWebsiteReportSummaryActions = getActionHookBuilder(
  websiteReportSummaryActions,
  [
    'setTrafficLoaded',
    'setTrafficTotals',
    'setTrafficMonthly',
    'setTrafficBusy',
    'setCompetitors',
    'setTopLiandings',
    'setWebsiteSummary',
    'reset',
  ],
);
